import { BaseService } from 'yellowfin-ui-lib';
import { AxiosInstance } from 'axios';
import { Specializzazione, SpecializzazioneAttivita, SpecializzazioneVoce } from '../models/specializzazione.model';

export class SpecializzazioneService extends BaseService {

  constructor(http: AxiosInstance) {
    super(http);
  }

  getAll(): Promise<Specializzazione[]> {
    return this.mapResponse(this.http.get(`web/specializzazioni`), Specializzazione);
  }

  getSpecII(spec1id: number): Promise<SpecializzazioneVoce[]> {
    return this.mapResponse(this.http.get(`web/specializzazioni/voci/${spec1id}`), SpecializzazioneVoce);
  }

  getSpecIII(spec2id: number): Promise<SpecializzazioneAttivita[]> {
    return this.mapResponse(this.http.get(`web/specializzazioni/voci/attivita/${spec2id}`), SpecializzazioneAttivita);
  }

}
